var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#842029"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8483 13.0983C17.5516 12.3951 18.5054 12 19.5 12C20.4946 12 21.4484 12.3951 22.1517 13.0983C22.8549 13.8016 23.25 14.7554 23.25 15.75C23.25 16.7446 22.8549 17.6984 22.1517 18.4017C21.4484 19.1049 20.4946 19.5 19.5 19.5C18.5054 19.5 17.5516 19.1049 16.8483 18.4017C16.1451 17.6984 15.75 16.7446 15.75 15.75C15.75 14.7554 16.1451 13.8016 16.8483 13.0983ZM19.5 13.5C18.9033 13.5 18.331 13.7371 17.909 14.159C17.4871 14.581 17.25 15.1533 17.25 15.75C17.25 16.3467 17.4871 16.919 17.909 17.341C18.331 17.7629 18.9033 18 19.5 18C20.0967 18 20.669 17.7629 21.091 17.341C21.5129 16.919 21.75 16.3467 21.75 15.75C21.75 15.1533 21.5129 14.581 21.091 14.159C20.669 13.7371 20.0967 13.5 19.5 13.5ZM18 22.5C17.4033 22.5 16.831 22.7371 16.409 23.159C15.9871 23.581 15.75 24.1533 15.75 24.75V26.25C15.75 26.6642 15.4142 27 15 27C14.5858 27 14.25 26.6642 14.25 26.25V24.75C14.25 23.7554 14.6451 22.8016 15.3483 22.0984C16.0516 21.3951 17.0054 21 18 21H21C21.9946 21 22.9484 21.3951 23.6516 22.0984C24.3549 22.8016 24.75 23.7554 24.75 24.75V26.25C24.75 26.6642 24.4142 27 24 27C23.5858 27 23.25 26.6642 23.25 26.25V24.75C23.25 24.1533 23.0129 23.581 22.591 23.159C22.169 22.7371 21.5967 22.5 21 22.5H18Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.8171229cdc8b37985685e1e0dbc1fb1b.svg";
export { ForwardRef as ReactComponent };